import { saveAs } from 'file-saver';
import { bufferToUrl, firefoxWorkaroundPdfDownload, hasValue } from '../helpers';
function showAudioDialog($mdDialog, logService, blobInfo) {
    const log = logService.getLogger('AudioPlayerDialog-C');
    $mdDialog.show({
        controllerAs: 'ctrl',
        controller: function () {
            this.cancel = () => $mdDialog.cancel();
            this.audioSrc = bufferToUrl(blobInfo.buffer, blobInfo.mimetype, log);
        },
        template: `
            <md-dialog translate-attr="{'aria-label': 'messageTypes.AUDIO_MESSAGE'}">
                    <md-toolbar>
                        <div class="md-toolbar-tools">
                            <h2 translate>messageTypes.AUDIO_MESSAGE</h2>
                            </div>
                    </md-toolbar>
                    <md-dialog-content layout="row" layout-align="center">
                        <audio controls autoplay ng-src="{{ ctrl.audioSrc | unsafeResUrl }}">
                            Your browser does not support the <code>audio</code> element.
                        </audio>
                    </md-dialog-content>
                    <md-dialog-actions layout="row" >
                      <md-button ng-click="ctrl.cancel()">
                         <span translate>common.OK</span>
                      </md-button>
                    </md-dialog-actions>
            </md-dialog>`,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
    });
}
export default [
    'LogService',
    'WebClientService',
    'MediaboxService',
    'MessageService',
    'TimeoutService',
    '$rootScope',
    '$mdDialog',
    '$timeout',
    '$transitions',
    '$translate',
    '$filter',
    '$window',
    function (logService, webClientService, mediaboxService, messageService, timeoutService, $rootScope, $mdDialog, $timeout, $transitions, $translate, $filter, $window) {
        const log = logService.getLogger('MessageMedia-C');
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=eeeMessage',
                receiver: '=eeeReceiver',
                showDownloading: '=eeeShowDownloading',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    $transitions.onStart({}, function (trans) {
                        mediaboxService.clearMedia();
                    });
                    this.$onInit = function () {
                        const message = this.message;
                        this.type = message.type;
                        this.downloading = false;
                        this.thumbnailDownloading = false;
                        this.downloaded = false;
                        this.uploading = message.temporaryId !== undefined
                            && message.temporaryId !== null;
                        this.isGif = message.type === 'file' && message.file.type === 'image/gif';
                        this.hasPreviewThumbnail = () => {
                            return hasValue(message.thumbnail) && (hasValue(message.thumbnail.previewDataUrl) || hasValue(message.thumbnail.preview));
                        };
                        this.getThumbnailPreviewUri = () => {
                            if (hasValue(message.thumbnail.previewDataUrl)) {
                                return message.thumbnail.previewDataUrl;
                            }
                            if (hasValue(message.thumbnail.preview)) {
                                message.thumbnail.previewDataUrl = bufferToUrl(message.thumbnail.preview, webClientService.appCapabilities.imageFormat.thumbnail, log);
                                return message.thumbnail.previewDataUrl;
                            }
                            return null;
                        };
                        this.getThumbnailPreviewUriStyle = () => {
                            const previewUri = hasValue(message.thumbnail) ? this.getThumbnailPreviewUri() : null;
                            return previewUri !== null ? `url(${previewUri})` : 'none';
                        };
                        this.thumbnail = null;
                        if (message.thumbnail !== undefined) {
                            this.thumbnailStyle = {
                                width: this.message.thumbnail.width + 'px',
                                height: this.message.thumbnail.height + 'px',
                            };
                        }
                        let loadingThumbnailTimeout = null;
                        this.wasInView = false;
                        this.thumbnailInView = (inView) => {
                            if (this.uploading || message.thumbnail === undefined || this.wasInView === inView) {
                                return;
                            }
                            this.wasInView = inView;
                            if (!inView) {
                                if (loadingThumbnailTimeout !== null) {
                                    timeoutService.cancel(loadingThumbnailTimeout);
                                }
                                this.thumbnailDownloading = false;
                                this.thumbnail = null;
                            }
                            else {
                                if (this.thumbnail === null) {
                                    const setThumbnail = (buf) => {
                                        this.thumbnail = bufferToUrl(buf, webClientService.appCapabilities.imageFormat.thumbnail, log);
                                    };
                                    if (message.thumbnail.img !== undefined) {
                                        setThumbnail(message.thumbnail.img);
                                        return;
                                    }
                                    else {
                                        this.thumbnailDownloading = true;
                                        loadingThumbnailTimeout = timeoutService.register(() => {
                                            webClientService
                                                .requestThumbnail(this.receiver, message)
                                                .then((img) => $timeout(() => {
                                                setThumbnail(img);
                                                this.thumbnailDownloading = false;
                                            }))
                                                .catch((error) => {
                                                const description = `Thumbnail request has been rejected: ${error}`;
                                                this.log.error(description);
                                            });
                                        }, 1000, false, 'thumbnail');
                                    }
                                }
                            }
                        };
                        this.location = null;
                        if (message.location !== undefined) {
                            this.location = message.location;
                            this.downloaded = true;
                        }
                        this.openMapLink = () => {
                            $window.open($filter('mapLink')(this.location), '_blank');
                        };
                        this.playAudio = (blobInfo) => showAudioDialog($mdDialog, logService, blobInfo);
                        this.download = () => {
                            log.debug('Download blob');
                            if (this.uploading) {
                                log.debug('Cannot download, still uploading');
                                return;
                            }
                            if (this.downloading) {
                                log.debug('Download already in progress...');
                                return;
                            }
                            const receiver = this.receiver;
                            this.downloading = true;
                            webClientService.requestBlob(message.id, receiver)
                                .then((blobInfo) => {
                                $rootScope.$apply(() => {
                                    log.debug('Blob loaded');
                                    this.downloading = false;
                                    this.downloaded = true;
                                    const options = { type: blobInfo.mimetype };
                                    switch (message.type) {
                                        case 'image':
                                            const caption = message.caption || '';
                                            mediaboxService.setMedia(blobInfo.buffer, blobInfo.filename, blobInfo.mimetype, caption);
                                            break;
                                        case 'video':
                                            saveAs(new Blob([blobInfo.buffer], options), blobInfo.filename);
                                            break;
                                        case 'file':
                                            if (message.file.type === 'image/gif') {
                                                this.blobBufferUrl = bufferToUrl(blobInfo.buffer, 'image/gif', log);
                                                this.showThumbnail = false;
                                            }
                                            else {
                                                options.type = firefoxWorkaroundPdfDownload(options.type);
                                                saveAs(new Blob([blobInfo.buffer], options), blobInfo.filename);
                                            }
                                            break;
                                        case 'audio':
                                            this.playAudio(blobInfo);
                                            break;
                                        default:
                                            log.warn('Ignored download request for message type', message.type);
                                    }
                                });
                            })
                                .catch((error) => {
                                $rootScope.$apply(() => {
                                    this.downloading = false;
                                    let contentString;
                                    switch (error) {
                                        case 'blobDownloadFailed':
                                            contentString = 'error.BLOB_DOWNLOAD_FAILED';
                                            break;
                                        case 'blobDecryptFailed':
                                            contentString = 'error.BLOB_DECRYPT_FAILED';
                                            break;
                                        default:
                                            contentString = 'error.ERROR_OCCURRED';
                                            break;
                                    }
                                    const confirm = $mdDialog.alert()
                                        .title($translate.instant('common.ERROR'))
                                        .textContent($translate.instant(contentString))
                                        .ok($translate.instant('common.OK'));
                                    $mdDialog.show(confirm);
                                });
                            });
                        };
                        this.isLoading = () => {
                            return this.uploading || this.isDownloading();
                        };
                        this.isDownloading = () => {
                            return this.downloading
                                || this.thumbnailDownloading
                                || (this.showDownloading && this.showDownloading());
                        };
                    };
                }],
            templateUrl: 'directives/message_media.html',
        };
    },
];
